var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.701439 16.4766C0.610576 16.4776 0.520423 16.4602 0.436166 16.4253C0.35191 16.3905 0.275214 16.3389 0.210491 16.2736C0.136285 16.1985 0.0791882 16.1076 0.0432817 16.0073C0.0073752 15.9071 -0.00645434 15.7999 0.00278178 15.6935L0.295462 11.9808C0.308013 11.8084 0.381923 11.6467 0.503171 11.5264L10.9453 0.832995C11.5271 0.275039 12.3012 -0.023966 13.0979 0.00150339C13.8894 0.00779273 14.6489 0.322367 15.2222 0.881338C15.772 1.45952 16.0882 2.22908 16.1075 3.03589C16.1267 3.8427 15.8476 4.62717 15.326 5.23217L4.8745 15.9739C4.75752 16.0932 4.60435 16.1683 4.4402 16.1866L0.767528 16.525L0.701439 16.4766ZM1.64557 12.3579L1.4473 15.007L4.03422 14.7653L14.3253 4.2073C14.5259 3.96412 14.6542 3.66706 14.6948 3.35143C14.7354 3.03579 14.6868 2.71484 14.5545 2.4267C14.4223 2.13857 14.2121 1.89536 13.9488 1.72597C13.6856 1.55657 13.3804 1.46812 13.0696 1.47112C12.8652 1.45783 12.6604 1.48695 12.4673 1.55673C12.2743 1.62651 12.097 1.73551 11.946 1.87719L1.64557 12.3579Z",
    fill: "#7B6F72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.cf8c10b44a122c15c01ae2032e7634c8.svg";
export { ForwardRef as ReactComponent };